<template>
    <proposal-provider
        v-slot="{
        proposal,
        campaign,
        contact,
        campaignFields,
        isLoading,
        proposalSteps,
        currentProposalStep,
        isProposalPreview,
        completeProposal,
        errorMessage,
        isCompletingProposal,
        fileUploadUrl,
        fileUploadHeaders,
        proposalFiles,
        isFileUploading,
        handleFileUpload,
        handleFileDelete,
        discountCodes,
        affiliateLink
    }">
        <proposal-overview-view
            :campaign="campaign"
            :contact="contact"
            :proposal="proposal"
            :campaign-fields="campaignFields"
            :is-proposal-preview="isProposalPreview"
            :proposal-steps="proposalSteps"
            :current-proposal-step="currentProposalStep"
            :is-loading="isLoading"
            :error-message="errorMessage"
            :is-completing-proposal="isCompletingProposal"
            :is-file-uploading="isFileUploading"
            @complete-proposal="completeProposal"
            @proposal-file-upload="handleFileUpload"
            @proposal-file-delete="handleFileDelete"
            :proposal-file-props="{
                fileUploadUrl,
                fileUploadHeaders,
                proposalFiles,
            }"
            :discount-codes="discountCodes"
            :affiliate-link="affiliateLink"
        />
    </proposal-provider>
</template>
<script>
    import ProposalOverviewView from "../data-views/proposals/ProposalOverviewView";
    import ProposalProvider from '../providers/ProposalsProvider';

    export default {
        name: "ProposalRouterView",
        components: {
            ProposalOverviewView,
            ProposalProvider,
        }
    }
</script>
